import * as types from './mutations_types.js'
import {app} from '../main'

// 為了設定語系引入 i18n
//import {app} from '../main'
//import i18n from '../main.js'

export const state = {
  loadCount: 0,
  loading: true,
  lang: localStorage.lang || 'tw',
  user: {
    iD: '',
    name: '匿名者',
    type: '',
    status: '4',
    loginTime: new Date(),
    isInit: false
  },
  appId: -1,
  pageId: -1
}

export const actions = {
  toggleLoading ({ commit }, isLoading) {
    commit(types.LOADING, isLoading)
  },
  // login
  actionLogin ({ commit }, user) {
    commit(types.USER, user)
  },
  resetLogin ({ commit }) {
    commit(types.CLEARUSER)
  },
  setLanguage ({ commit }, lang) {
    commit(types.LANGUAGE, lang)
  },
  actionIncrease ({ commit }) {
    commit(types.INCREASE)
  },
  actionDecrease ({ commit }) {
    commit(types.DECREASE)
  },
  actionResetCount ({ commit }) {
    commit(types.RESETCOUNT)
  },
  actionAppId ({ commit }, id) {
    commit(types.APPID, id)
  },
  actionPageId ({ commit }, id) {
    commit(types.PAGEID, id)
  }
}

export const mutations = {
  [types.LOADING] (state, isLoading) {
    state.loading = isLoading
  },
  [types.USER] (state, user) {
    console.log('set USER')
    state.user = user
  },
  [types.CLEARUSER] (state) {
    console.log('CLEAR USER')
    state.user = {
      iD: '',
      name: '匿名者',
      type: '',
      status: '4',
      loginTime: new Date(),
      isInit: false
    }
  },
  [types.LANGUAGE] (state, setlang) {
    state.lang = setlang
    // 設定 Vue config 將會改變使用的語系
    //i18n.locale = state.lang
    app.$i18n.locale = setlang
    localStorage.setItem('lang', setlang)

  },
  [types.INCREASE] (state, user) {
    state.loadCount++
  },
  [types.DECREASE] (state, user) {
    if (0 < state.loadCount) {
      state.loadCount--
    }
  },
  [types.RESETCOUNT] (state, user) {
    state.loadCount=0
  },
  [types.APPID] (state, id) {
    state.appId = id
  },
  [types.PAGEID] (state, id) {
    state.pageId = id
  }
}



// WEBPACK FOOTER //
// ./src/store/root.js